/**
 * base64文字列をバイナリに変換
 * @param base64String
 * @returns {boolean|Blob}
 */
export default function base64ToBinary(base64String) {
  const bin = atob(base64String.replace(/^.*,/, ''))
  const buffer = new Uint8Array(bin.length)
  const loop = [...Array(bin.length)]
  // eslint-disable-next-line no-return-assign
  loop.map((_, i) => buffer[i] = bin.charCodeAt(i))
  try {
    return new Blob([buffer.buffer], { type: 'image/png' })
  } catch (e) {
    return false
  }
}
